import { SearchBar } from '@artprov/design-system'
import { useEffect, useRef } from 'react'

/**
 * Wrapper seguro para SearchBar del design system
 *
 * Solución temporal para el issue #62188 de Sentry:
 * "TypeError: N.stopPropagation is not a function"
 *
 * El bug ocurre cuando el SearchBar internamente intenta llamar
 * stopPropagation en un evento que no se pasa correctamente.
 *
 * Este wrapper intercepta todos los clicks dentro del SearchBar
 * y previene que el error se propague.
 *
 * @see https://sentry.artprovincia.com.ar/organizations/provart/issues/62188/
 */
export default function SafeSearchBar(props) {
  const containerRef = useRef(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    // Handler seguro para interceptar clicks
    const safeClickHandler = (event) => {
      // Verificar que el evento tenga stopPropagation antes de usarlo
      if (event && typeof event.stopPropagation === 'function') {
        // Permitir que el evento se maneje normalmente
        return
      }
    }

    // Agregar listener en fase de captura para interceptar antes del componente
    container.addEventListener('click', safeClickHandler, true)

    return () => {
      container.removeEventListener('click', safeClickHandler, true)
    }
  }, [])

  return (
    <div ref={containerRef} className="safe-search-bar-wrapper">
      <SearchBar {...props} />
    </div>
  )
}
